<rappider-list-grid [config]="config"
                    [data]="uiStepFunctionData"
                    [loading]="isLoading"
                    (listActionClick)="navigateToUIStepFunctionCreate()"
                    (columnActionClick)="onUiStepFunctionListColumnActionClick($event)"></rappider-list-grid>